import Splide from '@splidejs/splide';

const productSlider = {
    timeout: false,
    delay: 250,

    init: function () {
        let self = this;
        let allSliders = document.querySelectorAll('.js-product-slider');


        if(allSliders.length > 0) {
            self._sliderCreate(allSliders);
            
        }
    },

    _sliderCreate(allSliders) {
        let self = this;
        allSliders.forEach((slider) => {
           self._build(slider);
        });

        
        self._update();
    },

    _build(node) {
        
        new Splide( node, {
            type: 'loop',
            speed: 800,
            accessibility: true,
            arrows: false,
            keyboard: true,
            autoplay: true,
            pagination: false,
            perPage: 5,
            gap: '16px',
            focus: 'start',
            breakpoints: {
                1200: {
                    perPage: 4
                },
                992:{
                    perPage: 3
                },
                768:{
                    perPage: 2
                },
                576: {
                    perPage: 1,
                }
            },
        }
        ).mount();
    },


    reInit() {
        let self = this;
        let node = document.querySelectorAll('.js-product-slider');

        if(node.length < 0) {
            return;
        }

        node.forEach(item => {
            if (!item.classList.contains('is-initialized')) {
                self._build(item);
            }
        });
        
    },

    _update() {
        window.lazyLoadInstance.update();
    }
};


window.productSlider = productSlider;

window.productSlider.init();

document.addEventListener('LokiRequestEnd', function () {
    window.productSlider.reInit();
});


window.addEventListener('resize', function() {
    // clear the timeout
    clearTimeout(productSlider.timeout);
    // start timing for event "completion"
    window.productSlider.timeout = setTimeout(window.productSlider._update(), window.productSlider.delay);
});
